module.exports = __webpack_public_path__ + "img/pushing.c30400ba.png";